<template>
    <div class="sub_company">
        <p class="title">{{ title }}</p>
        <table v-if="list.length">
            <thead class="thead">
            <tr>
                <td>排名</td>
                <td>企业</td>
                <td>舆情健康指数</td>
            </tr>
            </thead>
            <tbody class="tbody">
            <tr v-for="(item, index) in list" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>
                    <b v-if="item.value >= 80" class="co_green"><span class=" font_b fs22">{{ item.value }}</span>分</b>
                    <b v-else-if="item.value < 79 && item.value > 60 " class="co_orange"><span
                        class=" font_b fs22">{{ item.value }}</span>分</b>
                    <b v-else class="co_red"><span class=" font_b fs22">{{ item.value }}</span>分</b>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

export default {
    name: "common",
    props: {
        title: String,
        list: Array
    }
}
</script>

<style lang="scss" scoped>
.sub_company {
    height: auto;
    margin: 0 16px;
    box-sizing: border-box;
    padding: 8px 0;

    .title {
        background: url("../../assets/img/icon/media.png") no-repeat left;
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        text-indent: 20px;
        background-size: 18px 18px;
        margin-bottom: 12px;
    }

    .color-show {
        color: #FFB32E;
    }

    .color-FFF {
        color: #fff;
    }

    table {
        width: 100%;

        tr {
            width: 100%;
            text-align: center;

            td {
                &:nth-of-type(1) {
                    width: 15%;
                }

                &:nth-of-type(2) {
                    width: 45%;
                    text-align: left;
                }

                &:nth-of-type(3) {
                    width: 60%;
                    text-align: right;
                    padding-right: 16px;
                }
            }

        }

        .thead {
            tr {
                color: #666666;
                height: 28px;
                line-height: 28px;

                td {
                    padding: 6px 0;

                    &:nth-of-type(3) {
                        width: 65%;
                        text-align: right;
                        padding-right: 6px;
                    }
                }
            }
        }

        .tbody {
            tr {
                td {
                    font-family: PingFangSC-Regular;
                    color: #333333;
                    font-size: 14px;
                    line-height: 24px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>